export const defaultGroundNets = ['VSS', 'GND', 'GROUND', 'DGND', '0', 'NONET'];